/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SettingsPageLineActivationUserVariableListViewQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageLineActivationUserVariableListViewQuery = { userVariableDefinitions: Array<{ guid: string, name: string, value:
      | { __typename: 'UserVariableDefinitionValueMultipleSelect' }
      | { __typename: 'UserVariableDefinitionValueSelect' }
      | { __typename: 'UserVariableDefinitionValueString' }
      | { __typename: 'UserVariableDefinitionValueText' }
     }> };


export const SettingsPageLineActivationUserVariableListViewDocument = gql`
    query SettingsPageLineActivationUserVariableListView {
  userVariableDefinitions {
    guid
    name
    value {
      __typename
    }
  }
}
    `;

/**
 * __useSettingsPageLineActivationUserVariableListViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageLineActivationUserVariableListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageLineActivationUserVariableListViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageLineActivationUserVariableListViewQuery();
 */
export function useSettingsPageLineActivationUserVariableListViewQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageLineActivationUserVariableListViewQuery, SettingsPageLineActivationUserVariableListViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageLineActivationUserVariableListViewQuery, SettingsPageLineActivationUserVariableListViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageLineActivationUserVariableListViewQuery, SettingsPageLineActivationUserVariableListViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageLineActivationUserVariableListViewQuery, SettingsPageLineActivationUserVariableListViewQueryVariables>(SettingsPageLineActivationUserVariableListViewDocument, {}, options);
}
export function useSettingsPageLineActivationUserVariableListViewLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageLineActivationUserVariableListViewQuery, SettingsPageLineActivationUserVariableListViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageLineActivationUserVariableListViewQuery, SettingsPageLineActivationUserVariableListViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageLineActivationUserVariableListViewQuery, SettingsPageLineActivationUserVariableListViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageLineActivationUserVariableListViewQuery, SettingsPageLineActivationUserVariableListViewQueryVariables>(SettingsPageLineActivationUserVariableListViewDocument, {}, options);
}
export type SettingsPageLineActivationUserVariableListViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageLineActivationUserVariableListViewQuery, SettingsPageLineActivationUserVariableListViewQueryVariables>;